import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
`;
export const Line = styled.div`
  display: flex;
  width: 10px;
  border-radius: 6px;
  background-color: #74c598;
  height: 26px;
  margin-left: 21px;
`;
export const Container = styled.div`
  display: flex;
  gap: 14px;
`;
export const Icon = styled.div`
  display: flex;
  min-width: 50px;
  min-height: 50px;
  border-radius: 50px;
  background-color: #74c598;
  align-items: center;
  justify-content: center;

  & svg {
    font-size: 26px;
    color: #fff;
  }
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 8px;
  gap: 4px;
`;
export const Title = styled.p`
  font-size: 14px;
  color: #6e6e6e;
  font-weight: bold;
  margin: 0;
`;
export const Subtitle = styled.p`
  font-size: 14px;
  color: #aaaaaa;
  font-weight: normal;
  margin: 0;
`;
